const colors = {
  DARK_INDIGO: '#29508B',
  SKY_BLUE: '#4CC0E4',
  DIM_WHITE: '#CCDAE9',
  ORANGE: '#FFA300',
  BLACK: '#000'
};

const { DARK_INDIGO, SKY_BLUE, DIM_WHITE, ORANGE, BLACK } = colors;

export const AGE_CHART = [DARK_INDIGO, SKY_BLUE, ORANGE, DIM_WHITE, BLACK];
export const GENDER_CHART = [DARK_INDIGO, SKY_BLUE, DIM_WHITE, ORANGE, BLACK];
export const COMPARE_CHART = [DARK_INDIGO, ORANGE, DIM_WHITE, SKY_BLUE, BLACK];



// WEBPACK FOOTER //
// ./src/constants/charts.js